export default __webpack_public_path__ + "static/finalDream-e40f2adc11d9cd19da44b57cb1859fc1.svg";